module.exports = __webpack_public_path__ + "d8e65a08692cfbda54ded6082e9d099f.svg";